import { ShieldCheck } from 'lucide-react';

interface OAuthScopeListProps {
  scopes: Array<{
    scope: string;
    description: string;
  }>;
}

export function OAuthScopeList({ scopes }: OAuthScopeListProps) {
  return (
    <ul className="space-y-2">
      {scopes.map((s) => (
        <li key={s.scope} className="flex items-start gap-2 text-sm">
          <ShieldCheck className="h-4 w-4 mt-0.5 text-primary shrink-0" />
          <span>{s.description}</span>
        </li>
      ))}
    </ul>
  );
}
